/**
 * localStore — localStorage를 방어적으로 감싼 세 동사.
 *
 * 사생활 모드·용량 초과·SSR에서 `localStorage`는 던진다. 저장소 모듈(회차·진행·드래프트·
 * 프로필)이 전부 같은 try/catch를 들고 있었는데, 정책은 하나다: **읽기 실패는 null,
 * 쓰기·삭제 실패는 조용히 지나간다(best-effort)**. 한 곳에 두면 정책이 한 곳에서 바뀐다.
 */

export const readItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const writeItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* storage unavailable (private mode / quota) — best-effort */
  }
};

export const removeItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    /* best-effort */
  }
};
